import { HSLColor } from '@yola/yola-palette-generator';
import buildGradientModelByString from './build-gradient-model-by-string';
import { interpolateHslColorAtPosition } from './interpolate-hsl-color-at-position';
import isLightColorString from './is-light-hsl-color-string';
import isLightColorType from './is-light-color-type';
import resolveBlockBackgroundGradientFromOverrides from './resolve-block-background-gradient-from-overrides';

const MIDPOINT_POSITION = 50;

const getGradientMidpointColor = (gradient) => {
  const model = buildGradientModelByString(gradient);
  if (!model?.colorStops?.length) return null;

  const hsl = interpolateHslColorAtPosition(MIDPOINT_POSITION, model.colorStops);
  return new HSLColor(hsl.h, hsl.s, hsl.l, hsl.a);
};

const resolveVisualPreviewColor = ({ color, overrides }) => {
  const resolvedGradient = resolveBlockBackgroundGradientFromOverrides(overrides);
  const midpointColor = resolvedGradient ? getGradientMidpointColor(resolvedGradient) : null;
  const isDarkTheme = midpointColor ? !isLightColorType(midpointColor) : !isLightColorString(color);
  return {
    backgroundColor: resolvedGradient || color,
    isDarkTheme,
  };
};

export { resolveVisualPreviewColor };
